import React, {
    useState,
    useEffect
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faCamera
}
from "@fortawesome/free-solid-svg-icons";

import {
    useHistory
}
from "react-router-dom";

import {
    functions
}
from "../../../constants/common-functions";

import HomeBox
from "../components/HomeBox";

import {
    OMNISCAN_BLUE
}
from "../../../constants/colors";


export default function HomeBoxProperties({
    homeConfig,
    isMobile
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [facilityCount, setFacilityCount] =
        useState(0);

    const [scanPercent, setScanPercent] =
        useState(0);

    const [numberScans, setNumberScans] =
        useState(0);

    const [isLive, setIsLive] =
        useState(false);


    //--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // Load
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(facilityCount === 0)
            {
                functions.getObjectFromAjax(
                    "/resolutionsoftwareplatform/facilitycount",
                    null,
                    populateFacilityCount
                );
            }

            if(homeConfig)
            {
                setIsLive(
                    homeConfig.isLiveLinkScans
                );

                runCounter(
                    homeConfig.areaScanned
                );
            }
        },
        [homeConfig]
    );


    //--------------------------------------------------------
    // Animated counter
    //--------------------------------------------------------

    const runCounter =
        (val) =>
        {
            const target =
                val;

            let start =
                0;

            const delay =
                2000;

            const duration =
                900;

            const stepTime =
                30;

            const steps =
                duration / stepTime;

            const increment =
                target / steps;


            const timeout =
                setTimeout(
                    () =>
                    {
                        const counter =
                            setInterval(
                                () =>
                                {
                                    start +=
                                        increment;

                                    if(start >= target)
                                    {
                                        start =
                                            target;

                                        clearInterval(
                                            counter
                                        );
                                    }

                                    setScanPercent(
                                        Math.min(
                                            target,
                                            Math.round(start)
                                        )
                                    );
                                },
                                stepTime
                            );
                    },
                    delay
                );


            return () =>
                clearTimeout(
                    timeout
                );
        };


    //--------------------------------------------------------
    // Facility count
    //--------------------------------------------------------

    const populateFacilityCount =
        (countJsonObject) =>
        {
            setFacilityCount(
                countJsonObject.count
            );
        };


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goMap =
        () =>
        {
            history.push(
                "/map/-100"
            );
        };


    const goSpace =
        () =>
        {
            history.push(
                "/spaceall/-100"
            );
        };


    //========================================================
    // Main content
    //========================================================

	const thisContainer =
	{
	    display:
	        "flex",

	    width:
	        "100%",

	    minHeight:
	        "116px",

	    maxHeight:
	        "180px",

	    alignItems:
	        "stretch",

	    //--------------------------------------------------------
	    // Give the contents breathing room inside rounded HomeBox
	    //--------------------------------------------------------
	    padding:
	        "8px 10px",

	    boxSizing:
	        "border-box",

	    gap:
	        "10px"
	};


    //========================================================
    // Left metrics
    //========================================================

	const textContainer =
	{
	    display:
	        "flex",

	    flexDirection:
	        "column",

	    justifyContent:
	        "center",

	    flex:
	        1,

	    padding:
	        "0px",

	    boxSizing:
	        "border-box",

	    gap:
	        "8px"
	};


    //--------------------------------------------------------
    // Flat metric row
    //--------------------------------------------------------

    const numberRow =
    {
        display:
            "flex",

        alignItems:
            "center",

        height:
            "38px",

        width:
            "100%",

        margin:
            "0px",

        padding:
            "0px",

        boxSizing:
            "border-box",

        background:
            "rgba(20,24,28,0.035)",

        border:
            "1px solid rgba(20,24,28,0.09)",

        borderRadius:
            "0px",

        boxShadow:
            "none",

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Number block
    //--------------------------------------------------------

    const numberContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "76px",

        alignSelf:
            "stretch",

        flexShrink:
            0,

        fontSize:
            "18px",

        fontWeight:
            700,

        color:
            "#ffffff",

        borderRadius:
            "0px",

        border:
            "none",

        boxShadow:
            "none"
    };


    //--------------------------------------------------------
    // Label
    //--------------------------------------------------------

    const numberLabel =
    {
        display:
            "flex",

        alignItems:
            "center",

        flex:
            1,

        color:
            "#344454",

        fontSize:
            "13px",

        marginLeft:
            "14px",

        fontWeight:
            500
    };


    //========================================================
    // Area scanned panel
    //========================================================

	const chartContainer =
	{
	    display:
	        "flex",

	    width:
	        "42%",

	    minWidth:
	        "160px",

	    flexDirection:
	        "column",

	    alignSelf:
	        "stretch",

	    flexShrink:
	        0
	};


	const chartTile =
	{
	    position:
	        "relative",

	    display:
	        "flex",

	    flexDirection:
	        "column",

	    alignItems:
	        "center",

	    justifyContent:
	        "center",

	    flex:
	        1,

	    width:
	        "100%",

	    minHeight:
	        "100%",

	    margin:
	        "0px",

	    padding:
	        "0px",

	    boxSizing:
	        "border-box",

	    overflow:
	        "hidden",

	    background:
	        `
	        linear-gradient(
	            135deg,
	            #292d31 0%,
	            #15181b 58%,
	            #0d0f11 100%
	        )
	        `,

	    border:
	        "none",

	    borderRadius:
	        "0px",

	    boxShadow:
	        `
	        inset 0 1px 0 rgba(255,255,255,0.08),
	        inset 1px 0 0 rgba(255,255,255,0.035)
	        `
	};


    //--------------------------------------------------------
    // Black / smoked watermark
    //--------------------------------------------------------

    const watermarkStyle =
    {
        position:
            "absolute",

        right:
            "-20px",

        bottom:
            "-25px",

        width:
            "120px",

        height:
            "120px",

        //----------------------------------------------------
        // Dark watermark rather than blue
        //----------------------------------------------------

        color:
            "#000000",

        opacity:
            0.28,

        transform:
            "rotate(-8deg)",

        pointerEvents:
            "none",
			
			
    };


    //--------------------------------------------------------
    // Metric label
    //--------------------------------------------------------

    const metricLabel =
    {
        position:
            "relative",

        zIndex:
            2,

        fontSize:
            "11px",

        fontWeight:
            600,

        letterSpacing:
            "1.4px",

        textTransform:
            "uppercase",

        //----------------------------------------------------
        // Small OmniScan accent retained
        //----------------------------------------------------

        color:
            "#8dc8f0",

        marginBottom:
            "5px"
    };


    //--------------------------------------------------------
    // Big metric
    //--------------------------------------------------------

    const bigMetric =
    {
        position:
            "relative",

        zIndex:
            2,

        fontSize:
            "34px",

        lineHeight:
            "38px",

        fontWeight:
            700,

        color:
            "#ffffff",

        letterSpacing:
            "-1px"
    };


    //--------------------------------------------------------
    // Small underline
    //--------------------------------------------------------

    const metricUnderline =
    {
        position:
            "relative",

        zIndex:
            2,

        width:
            "28px",

        height:
            "2px",

        marginTop:
            "8px",

        background:
            "#8dc8f0",

        opacity:
            0.8
    };


    //========================================================
    // Render
    //========================================================

    return (

        <HomeBox
            isMobile={isMobile}
            isLive={isLive}
            title="Scans"
            color={OMNISCAN_BLUE}
            colorRgb={OMNISCAN_BLUE}
            clickFunction={goMap}
            icon="camera"
            delay={360}
        >

            <div style={thisContainer}>


                {/* ============================================
                    LEFT METRICS
                ============================================= */}

                <div style={textContainer}>


                    {/* Properties */}

                    <div style={numberRow}>

                        <div
                            style={{
                                ...numberContainer,

                                background:
                                    "#e89325"
                            }}
                        >

                            {
                                functions.formatNumber(
                                    facilityCount,
                                    0
                                )
                            }

                        </div>

                        <div style={numberLabel}>

                            Properties

                        </div>

                    </div>


                    {/* Scans */}

                    <div style={numberRow}>

                        <div
                            style={{
                                ...numberContainer,

                                background:
                                    "#7145e8"
                            }}
                        >

                            {
                                functions.formatNumber(
                                    numberScans,
                                    0
                                )
                            }

                        </div>

                        <div style={numberLabel}>

                            Scans

                        </div>

                    </div>


                </div>


                {/* ============================================
                    AREA SCANNED
                ============================================= */}

                <div style={chartContainer}>

                    <div style={chartTile}>


                        {/* Black watermark */}

                        <FontAwesomeIcon
                            icon={faCamera}
                            style={watermarkStyle}
                        />


                        {/* Label */}

                        <div style={metricLabel}>

                            Area Scanned

                        </div>


                        {/* Value */}

                        <div style={bigMetric}>

                            {scanPercent}%

                        </div>


                        {/* Accent */}

                        <div style={metricUnderline} />


                    </div>

                </div>


            </div>

        </HomeBox>

    );
}